import { GROUP_ID_QUERY_PARAM } from "features/bots/common/constants";
import useHistoryWithQuery from "utils/hooks/useHistoryWithQuery";
import {
  FiltersActions,
  FiltersSelector,
  FilterType,
  WorkspaceType,
} from "@shared/types";
import { groupConfigurationsFilters } from "@shared/slices/filters.slice";
import { useFilter } from "@shared/features/filters/useFilter";
import useQuery from "utils/hooks/useQuery";
import { useEffect } from "react";
import { selectWorkspace } from "@shared/slices/common.slice";
import { skipToken } from "@reduxjs/toolkit/query";
import { useSelector } from "react-redux";
import { sharedLib } from "@shared/services/shared.service";

interface useAdminGroupsSelectProps {
  filtersSelectors?: FiltersSelector;
  filtersActions?: FiltersActions;
}
export const useAdminGroupsSelect = ({
  filtersSelectors = groupConfigurationsFilters.selectors,
  filtersActions = groupConfigurationsFilters.actions,
}: useAdminGroupsSelectProps) => {
  const { appendQuery } = useHistoryWithQuery();
  const groupsFilterSectionData = useFilter({
    filterType: FilterType.GROUPS,
    filtersActions,
    filtersSelectors,
  });
  const query = useQuery();
  const subGroupIdStr = query.get(GROUP_ID_QUERY_PARAM) || "";
  const querySubGroupId = subGroupIdStr ? Number(subGroupIdStr) : undefined;

  const updateUrl = (groupId: number) => {
    appendQuery({ [GROUP_ID_QUERY_PARAM]: groupId.toString() });
  };

  return {
    updateUrl,
    groupsFilterSectionData,
    querySubGroupId,
  };
};

export const useInitAdminGroupsSelect = () => {
  const { groupsFilterSectionData, querySubGroupId } = useAdminGroupsSelect({});
  const workspace = useSelector(selectWorkspace);
  const isAdmin = workspace === WorkspaceType.ADMIN;
  const { data } = sharedLib.sharedApi.admin.useGetAdminSubGroupsQuery(
    isAdmin ? undefined : skipToken
  );

  useEffect(() => {
    if (
      data &&
      querySubGroupId &&
      data.find((group) => group.id === querySubGroupId)
    ) {
      groupsFilterSectionData.onChange([querySubGroupId]);
    }
  }, [data]);
};
